import { ActionHistory, futureAtom, pastAtom } from './historyAtoms';
import { useAtom } from 'jotai';
import { useUpdateCJSeance } from './useUpdateCJSeance';
import { useDeleteCJSeances } from './useDeleteCJSeances';
import { CJEvent } from 'types/event';
import { logNetworkError } from 'utils/errors';
import { useSetCJSeanceStatus } from './useSetCJSeanceStatus';
import { useRestoreCJSeances } from './useRestoreCJSeances';

export function useUndoCJ() {
  const [past, setPast] = useAtom(pastAtom);
  const [future, setFuture] = useAtom(futureAtom);
  const updateEvent = useUpdateCJSeance(true);
  const setCJSeancesStatus = useSetCJSeanceStatus(true);
  const removeEvents = useDeleteCJSeances(true);
  const restoreEvents = useRestoreCJSeances();

  return () => {
    const lastItem = past.pop() as ActionHistory;
    setPast(past);

    switch (lastItem.action) {
      case 'CREATE':
        setFuture([
          {
            action: 'DELETE',
            payload: lastItem.payload as CJEvent[],
          },
          ...future,
        ]);
        return removeEvents(lastItem.payload as CJEvent[]);
      case 'DELETE': {
        setFuture([
          {
            action: 'RESTORE',
            payload: lastItem.payload as CJEvent[],
          },
          ...future,
        ]);
        return restoreEvents({
          ids: ((lastItem.payload || []) as CJEvent[]).map(ev => ev.id),
        }).catch(err => {
          logNetworkError(err, "Couldn't restore cj event when undo");
        });
      }
      case 'UPDATE': {
        const [oldEvent, newEvent] = lastItem.payload as CJEvent[];
        setFuture([
          {
            action: 'UPDATE',
            payload: [newEvent, oldEvent] as CJEvent[],
          },
          ...future,
        ]);
        return updateEvent({
          event: oldEvent,
          previousDay: newEvent.start,
        });
      }
      case 'UPDATE_STATUS': {
        const { status, date } = lastItem.payload;
        setFuture([
          {
            action: 'UPDATE_STATUS',
            payload: {
              date,
              status: status === 'done' ? 'open' : 'done',
            },
          },
          ...future,
        ]);
        return setCJSeancesStatus({
          date,
          status,
        });
      }
      default:
        throw new Error(
          `history action not recognized : ${
            (lastItem as ActionHistory).action
          }`,
        );
    }
  };
}
